import { requestApi } from './Api';

export const generatePdf = async (navigate, params) =>
  requestApi({ navigate, url: '/api/pdf/generate', params, responseType: 'blob' });

export const generateInvoicePdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/internal/pdf',
    params,
    responseType: 'blob'
  });

export const generateReceiptPdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/receipt/pdf',
    params,
    responseType: 'blob'
  });

export const generateAppointmentReceiptsPdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/transactions/receipt/appointment/pdf',
    params,
    responseType: 'blob'
  });

export const generateSuperbillPdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/superbill/pdf',
    params,
    responseType: 'blob'
  });

export const generateGoodFaithEstimatePdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/checkin/gfe_pdf',
    params,
    responseType: 'blob'
  });

export const generateCheckinInvoicePdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/checkin/invoice_pdf',
    params,
    responseType: 'blob'
  });

export const generateQuotePdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/quote/pdf',
    params,
    responseType: 'blob'
  });

export const generatePreAuthPdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/pre_auth/pdf',
    params,
    responseType: 'blob'
  });

export const generateEligibilityBreakdownPdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/insurance/breakdown/pdf',
    params,
    responseType: 'blob'
  });
